import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=057617ec&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=057617ec&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057617ec",
  null
  
)

export default component.exports